import CellHero from "../components/CellHero";
import CellFocus from "../components/CellFocus";
import CellPathwayNav from "../components/CellPathwayNav";
import CellLeadership from "../components/CellLeadership";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function TextileEfficiencyCellPage() {
  return (
    <main className="min-h-screen">
      <CellHero
        name="Textile Efficiency Cell"
        tagline="Lean Management, Waste Elimination, and Flow Optimization"
        description="The Textile Efficiency Cell is the operational backbone of innovation. It applies lean principles, resource optimization, and preventive discipline to compress lead times, reduce waste, and maximize output from existing assets."
        icon="ri-speed-line"
      />

      <CellFocus
        focus={[
          "Lean management & waste elimination",
          "Resource efficiency optimization",
          "Lead-time compression & flow optimization",
          "Preventive maintenance & planning discipline",
        ]}
        description="Efficiency is not about working harder — it is about removing the friction that slows everything down. This cell diagnoses operational waste, redesigns workflows, and installs the planning discipline that keeps improvements alive long after consultants leave."
      />

      <CellLeadership
        chiefCatalyst={{
          name: "Engr. Shafiur Rahman",
          designation: "Country Manager, G-Star Raw",
        }}
        moderators={[
          {
            name: "Engr. Abu Hasnat",
            designation: "Founder, Caterfly",
          },
        ]}
      />

      {/* Related Programmes */}
      <section className="bg-tie-navy py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/10 border border-white/20 mb-4 md:mb-5">
                  <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">
                    / Related Programmes
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                  Efficiency-Driven Innovation
                </h2>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                { name: "PIIC", desc: "Efficiency-focused Innovation Circles for lean and waste reduction", route: "/piic" },
                { name: "PTIM", desc: "Validate efficiency interventions before factory-wide rollout", route: "/ptim" },
                { name: "Training", desc: "Lean certification and efficiency management programmes", route: "/training" },
                { name: "Experts", desc: "Lean specialists and operations optimization consultants", route: "/experts" },
              ].map((prog, index) => (
                <ScrollReveal key={prog.name} delay={index * 100}>
                  <Link to={prog.route} className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                    <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                    <p className="text-sm text-white/60">{prog.desc}</p>
                    <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                      Learn more <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform" />
                    </span>
                  </Link>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CellPathwayNav />
    </main>
  );
}